import { type ReactNode } from "react";
import Icon from "@/components/ui/Icon";
// import { useConfig } from "@/providers";

interface McapProgressBarProps {
    /** Graduation percentage from Anoncoin API (0–100) */
    graduationPct: number;
    /** Current market cap (SOL) for display */
    currentMcap?: number;
    /** 24H price change string e.g. "5.2%" or "-3.1%" */
    priceChange24h?: string;
}

export default function McapProgressBar({
    graduationPct,
}: McapProgressBarProps): ReactNode {
    // const { MIGRATION_MC_SOL } = useConfig();
    const progress = Math.min(Math.max(graduationPct, 0), 100);
    const isTargetReached = progress >= 100;

    // const formatMcap = (val: number) => {
    //     if (val >= 1_000_000) return `${parseFloat((val / 1_000_000).toFixed(1))}M`;
    //     if (val >= 1_000) return `${parseFloat((val / 1_000).toFixed(1))}K`;
    //     return parseFloat(val.toFixed(1)).toString();
    // };

    return (
        <div className="mb-4">
            <div className="bg-gradient-to-b from-[rgba(115,115,115,0)] to-[rgba(115,115,115,0.2)] border-[0.5px] border-[rgba(153,153,153,0.5)] rounded-[12px] p-4 overflow-hidden">
                {/* Header */}
                <div className="flex items-center justify-between mb-5">
                    <div className="flex items-center gap-[6px]">
                        <Icon name="focus-target" size={12} className="opacity-60" />
                        <p className="text-[13px] font-semibold text-white font-[family-name:var(--font-display)]">
                            Bonding Curve Progress
                        </p>
                    </div>
                    <div className="flex items-center gap-2">
                        {/* {currentMcap !== undefined && currentMcap > 0 && (
                            <p className="text-[13px] font-semibold text-white/50 font-[family-name:var(--font-display)]">
                                {formatMcap(currentMcap)} SOL
                            </p>
                        )} */}
                        <p className={`text-[13px] font-semibold font-[family-name:var(--font-display)] ${isTargetReached ? "text-[#4ade80]" : "text-[#f3ce28]"
                            }`}>
                            {Math.round(progress)}%
                        </p>
                    </div>
                </div>

                {/* Progress Bar */}
                <div className="h-2 w-full bg-[rgba(255,255,255,0.08)] rounded-full overflow-hidden">
                    <div
                        className={`h-full rounded-full transition-all duration-700 ${isTargetReached ? "bg-[#4ade80]" : "bg-[#f3ce28]"
                            }`}
                        style={{ width: `${Math.max(progress, 1)}%` }}
                    />
                </div>

                {isTargetReached ? (
                    <p className="text-[10px] text-[#4ade80] font-semibold mt-3 font-[family-name:var(--font-display)]">
                        Target Reached — Unlocking!
                    </p>
                ) : null
                /* (
                    <div className="flex justify-between mt-[clamp(8px,1dvh,12px)]">
                        <div className="flex flex-col gap-1">
                            <p className="text-[10px] font-normal text-white/40 font-[family-name:var(--font-display)]">MCAP</p>
                            <div className="flex items-baseline gap-1.5">
                                <p className="text-[14px] font-medium text-white tracking-[-0.28px] font-[family-name:var(--font-display)]">
                                    {currentMcap !== undefined && currentMcap > 0 ? formatMcap(currentMcap) : "—"} SOL
                                </p>
                                {priceChange24h && (() => {
                                    const changeVal = parseFloat(priceChange24h.replace("%", "")) || 0;
                                    const signedChange = `${changeVal >= 0 ? "+" : ""}${priceChange24h}`;
                                    return (
                                    <span className="text-[11px] font-medium tracking-[-0.22px] leading-[1.15] font-[family-name:var(--font-display)]">
                                        <span className={changeVal >= 0 ? "text-[#4ade80]/70" : "text-red-400/70"}>
                                            {signedChange}
                                        </span>
                                        <span className="text-white/40"> in 24H</span>
                                    </span>
                                    );
                                })()}
                            </div>
                        </div>
                        <div className="flex flex-col gap-1 items-end">
                            <p className="text-[10px] font-normal text-white/40 font-[family-name:var(--font-display)]">Target</p>
                            <p className="text-[14px] font-medium text-white tracking-[-0.28px] font-[family-name:var(--font-display)]">
                                {formatMcap(MIGRATION_MC_SOL)} SOL
                            </p>
                        </div>
                    </div>
                ) */}
            </div>
        </div>
    );
}
